if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if(this.form.querySelector('[name=id]') != null) this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.productGridForm = this.classList.contains('product-grid-form');
        this.variantSwatches = this.form.querySelectorAll('[data-variant-swatch]');
        this.subOptions = this.form.querySelectorAll('.product_subscription_type input')
        let productForms = document.querySelectorAll('[data-grid-prd-form]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        if(this.productGridForm){
          var _this = this;


          this.variantSwatches.forEach(swatch => {
            this.onVariantSwatchChange(swatch,'variant-swatch');
          });

          this.subOptions.forEach(subOption => {
            this.onVariantSwatchChange(subOption,'sub-options');
          });

          // _this.onVariantSwatchChange(_this.variantSwatches);
          if(window.innerWidth > 1100){
            
            this.addEventListener('mouseover',function(e){
              _this.openATCPanel(this,_this,productForms);
            });
            this.querySelector('button').addEventListener('focus',function(e){
              _this.openATCPanel(this.closest('.product-grid-form'),_this,productForms);
            });
            this.addEventListener('mouseout',function(e){
              _this.closeATCPanel(this);
            })
          } else{
            if(!$(this).hasClass('sale-collection')){
              if(this.querySelector('[data-add-step][type="submit"]') != null) this.querySelector('[data-add-step][type="submit"]').type = 'button';
              this.addEventListener('click',function(e){
                e.stopPropagation();
                if(!e.target.matches('label.variant-label') && !e.target.matches('input[name="id"]')){ // dont close if same box is being clicked
                  _this.openATCPanel(this,_this,productForms);
                }
              });
  
              document.querySelector('body').addEventListener('click',function(e){
                e.stopPropagation();
                if(e.currentTarget != _this){
                  _this.closeATCPanel(_this);
                }
              })
            }
          }
          
          document.querySelectorAll('[data-grid-prd-form] input[name="id"]').forEach(function(input){
            input.addEventListener('change',function(e){
              e.stopImmediatePropagation();
              let form = this.closest('form');
              const atcMessage = form.querySelector('.atc-text');
              const soldOutMessage = form.querySelector('.sold-out-message');
              if(input.hasAttribute('data-soldout')){
                if (!soldOutMessage) return;
                form.querySelector('button[name="add"]').setAttribute('aria-disabled', true);
                form.querySelector('button[name="add"]').querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                atcMessage.classList.add('hidden');
                atcMessage.classList.remove('block');
              } else{
                if (!soldOutMessage) return;
                form.querySelector('button[name="add"]').setAttribute('aria-disabled', false);
                form.querySelector('button[name="add"]').querySelector('span').classList.remove('hidden');
                soldOutMessage.classList.add('hidden');
                atcMessage.classList.remove('hidden');
                atcMessage.classList.add('block');
              }
            })  
          })
        }
      }
      onVariantSwatchChange(swatch,type){
        if(type == 'variant-swatch'){
          swatch.addEventListener('click',function(e){
            let swtch = e.currentTarget.closest('[data-card-variants]').querySelector('input[id='+e.currentTarget.getAttribute('for')+']');
            let subBox = e.currentTarget.closest('.atc-panel').querySelector('.product_subscription_type');
            let atcBtnPrice = e.currentTarget.closest('[data-grid-prd-form]').querySelector('[data-atc-price]');
            let atcBtncompPrice = e.currentTarget.closest('[data-grid-prd-form]').querySelector('[data-compare-price]');
            let atcBtnsavingper = e.currentTarget.closest('[data-atc-container]').querySelector('[data-saving-percentage]');
            let freqMsg = e.currentTarget.closest('[data-grid-prd-form]').querySelector('[data-grid-freq-msg-container]');
            var free_gift_id = $(swtch).attr("variant_free_gift_id") 
            $(this).parents('form').find('.free_gift_product_data').attr('free_gift_id',free_gift_id)

            if(subBox != null){
               // change prices
              // if(subBox.querySelector('[data-cur-comp-price]') != null) subBox.querySelector('[data-cur-comp-price]').innerHTML = swtch.dataset.comPrice;
              if(subBox.querySelectorAll('[data-cur-comp-price]') != null) subBox.querySelectorAll('[data-cur-comp-price]').forEach((ele) => {ele.innerHTML = swtch.dataset.comPrice;})
              if(subBox.querySelectorAll('[data-cur-price]') != null) subBox.querySelectorAll('[data-cur-price]').forEach((ele) => {ele.innerHTML = swtch.dataset.price;})
              if(subBox.querySelector('.onetime-option [data-atc-prc]') != null) subBox.querySelector('.onetime-option [data-atc-prc]').dataset.atcPrc = swtch.dataset.price;
              if(subBox.querySelector('[data-cur-sub-price]') != null) subBox.querySelector('[data-cur-sub-price]').innerHTML = swtch.dataset.subPrice;
              
              if(subBox.querySelector('.subscription-option [data-atc-prc]') != null) {
                subBox.querySelector('.subscription-option [data-atc-prc]').dataset.atcPrc = swtch.dataset.subPrice;
                if(swtch.dataset.sellingPlan != undefined && swtch.dataset.sellingPlan != '' ){
                  subBox.querySelector('.subscription-option [data-atc-prc]').value = swtch.dataset.sellingPlan;
                }
                
              }
            }
            if(e.currentTarget.closest('.atc-panel').querySelector('[data-discount-badge]') != null) e.currentTarget.closest('.atc-panel').querySelector('[data-discount-badge]').innerHTML = swtch.dataset.compDiscount + '% OFF';  

            if($(e.currentTarget.closest('.atc-panel')).find('.card_variantbase_media[data-vid="'+swtch.value.toLowerCase()+'"]').length > 0){
              $(e.currentTarget.closest('.atc-panel')).find('.card_variantbase_media').hide();
              $(e.currentTarget.closest('.atc-panel')).find('.card_variantbase_media[data-vid="'+swtch.value.toLowerCase()+'"]').show();                 
            }   
            
            if(atcBtnPrice != null) {
              if(subBox != null){ // subscription exists
                atcBtnPrice.innerHTML = subBox.querySelector('input:checked').dataset.atcPrc;
              } else{
                atcBtnPrice.innerHTML = swtch.dataset.price;                
              }
            }
            if(atcBtncompPrice != null) {
              atcBtncompPrice.innerHTML = swtch.dataset.comPrice;
            }
            if(atcBtnsavingper != null) {
              if(swtch.dataset.compDiscount != ''){
                atcBtnsavingper.innerHTML = `<span class="saving_percentage">${swtch.dataset.compDiscount}% OFF</span>`;
              }else{
                atcBtnsavingper.innerHTML = '';  
              }
              
            }
            if(freqMsg != null  && swtch.dataset.freqMsgFirstPart != '' && swtch.dataset.freqMsgLastPart != ''){
              let freqFirstPart = swtch.dataset.freqMsgFirstPart
              let freqLastPart = swtch.dataset.freqMsgLastPart
              freqMsg.innerHTML = `<span class="light">${freqFirstPart}</span> ${freqLastPart}` 
            }
            var maxqty = parseInt(swtch.dataset.maxqty);
            var cartqty = parseInt(swtch.dataset.cartqty);
            let atcBtn = e.currentTarget.closest('[data-grid-prd-form]').querySelector('.quick-add__submit');
            let maxqtyerr = e.currentTarget.closest('[data-grid-prd-form]').querySelector('.maxqty_err');
            if(cartqty >= maxqty){              
              atcBtn.classList.add('forcedisable');
              if(maxqtyerr){                
              maxqtyerr.style.display = 'block';
              }
            }else{
              atcBtn.classList.remove('forcedisable');
              if(maxqtyerr){                
              maxqtyerr.style.display = 'none';
              }
            }
          })
        } else if (type == 'sub-options'){
          swatch.addEventListener('change',function(e){
            if(swatch.closest('[data-atc-container]').querySelector('[data-product-custom-diet-box]')!= null){
              swatch.closest('[data-atc-container]').querySelector('[data-product-custom-diet-box] input').checked = swatch.value != '' ? true : false;
            }
            let atcBtnPrice = e.currentTarget.closest('[data-grid-prd-form]').querySelector('[data-atc-price]');
            if(atcBtnPrice != null) atcBtnPrice.innerHTML = e.currentTarget.dataset.atcPrc;
          });
        }
          
    
      }
      openATCPanel(ele,_this,productForms){
        productForms.forEach(function(form){
          if(ele != form){
            _this.closeATCPanel(form);
          }
        })
        
        ele.querySelector('button').classList.add('active');
        if(ele.querySelector('.atc-panel') != null) ele.querySelector('.atc-panel').classList.add('show');
        
        if(window.innerWidth<=1100 && ele.querySelector('[type="button"]') != null){
          setTimeout(function(){
            ele.querySelector('[type="button"]').type = 'submit';
          },50)
        }
      }
      closeATCPanel(ele){
        ele.querySelector('button').classList.remove('active');
        if(ele.querySelector('.atc-panel') != null) ele.querySelector('.atc-panel').classList.remove('show');

        if(window.innerWidth<=1100){
          setTimeout(function(){
           if(ele.querySelector('[data-add-step][type="submit"]') != null) ele.querySelector('[data-add-step][type="submit"]').type = 'button';
          },50)
        }
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        var __this = this;
        const atcLiveRegion = this.querySelector('#cart-atc-live-region');

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        atcLiveRegion.innerHTML = 'Adding....'

        var formData = new FormData(this.form); 
        function showToast(target) {
          let existingToast = document.querySelector('.toast');
          if (existingToast) {
              existingToast.remove();
          }
      
          const toast = document.createElement('div');
          toast.className = 'toast';
          toast.innerHTML = `<span class="icon_toast">
          <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit" viewBox="0 0 22 22" aria-hidden="true" width="22" height="22"><path fill="#b71c1c" d="M10.083 13.75h1.833v1.833h-1.833zm0-7.333h1.833v5.5h-1.833zm.907-4.583C5.931 1.833 1.833 5.94 1.833 11s4.097 9.167 9.158 9.167c5.069 0 9.176-4.107 9.176-9.167s-4.107-9.167-9.176-9.167m.009 16.5c-4.052 0-7.333-3.282-7.333-7.333S6.949 3.667 11 3.667 18.333 6.949 18.333 11 15.051 18.333 11 18.333"/></svg>
          </span>
          <span class="message">
          <h3>Maximum quantity reached.</h3>
          <p>For bulk orders email us at: <a href="mailto:b2b.global@plixlife.com">b2b.global@plixlife.com</a></p>
          </span>
          <span class="closethis_pop" onclick="this.closest('.toast').remove()">        
            <svg width="12" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.292893 14.6147C-0.0976311 15.0052 -0.0976311 15.6384 0.292893 16.0289C0.683417 16.4194 1.31658 16.4194 1.70711 16.0289L0.292893 14.6147ZM1.70711 16.0289L15.7071 2.02888L14.2929 0.614671L0.292893 14.6147L1.70711 16.0289Z" fill="#7C211C"/>
              <path d="M1.70711 0.61467C1.31658 0.224146 0.683417 0.224146 0.292893 0.61467C-0.0976314 1.00519 -0.0976315 1.63836 0.292893 2.02888L1.70711 0.61467ZM0.292893 2.02888L14.2929 16.0289L15.7071 14.6147L1.70711 0.61467L0.292893 2.02888Z" fill="#7C211C"/>
            </svg>
          </span>`;
      
           $(target).append(toast);
      
          // setTimeout(() => {
          //     toast.style.opacity = '0';
          //     setTimeout(() => toast.remove(), 500);
          // }, 3000);
        }
        
        var varaddid = formData.get('id');
        var thisitemid = formData.get('product-id');
        const variantData = JSON.parse($('#VariantJSON-'+thisitemid).html());
        var maxqty = parseInt(variantData[varaddid].max_qty);
        var donotgo = false;
        if($(__this).is('[data-grid-prd-form]')){
          var addingqty = 1;
        }else{
          var addingqty = parseInt(formData.get('quantity'));
        }
        var cartdata = window.cartdata;
        if(cartdata.item_count > 0){
          const matchedVariant = cartdata.items.find(v => v.id == varaddid);
          if(matchedVariant){
            var totaladdedqty = parseInt(matchedVariant.quantity) + addingqty;
            if(totaladdedqty > maxqty){
              donotgo = true;
            }
          }else if(addingqty > maxqty){
            donotgo = true;
          }
        }else{
          if(addingqty > maxqty){
            donotgo = true; 
          }
        }

        let stickyATCBtn = document.querySelector('[data-sticky-atc]');
        if(donotgo){
          __this.submitButton.classList.remove('loading');
          __this.submitButton.removeAttribute('aria-disabled');
          __this.querySelector('.loading-overlay__spinner').classList.add('hidden');              
          atcLiveRegion.innerHTML = 'Added to cart';
          if(__this.hasAttribute('data-grid-prd-form')){
            showToast(__this);
          }else{
            showToast(__this.closest('.product-form__quantity__wrapper'));  
          }
          
          
          if(stickyATCBtn != null){
            stickyATCBtn.querySelector('.product-form__buttons__text').classList.remove('hidden');
            stickyATCBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
          return;
        }

        let RandomNumber = Math.floor(Math.random() * 90000) + 10000;
        

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];    
        $('.sub-product_meta-property').remove();
        var freeProductId = parseInt($(__this).find(`.free_gift_product_data:checked`).attr('free_gift_id'));
        var items = [];
        var randomId = Math.random().toString(36).substring(2, 12);
        function addOnProducts() {
          items.push({
            quantity: 1,
            id: freeProductId,
            properties: {
              '_personalize': 'sub',
              '_type': 'free_gift',
              '_bundleid': randomId
            }
          })
          var data = {items};
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async: false,
            data: {items},
            dataType: 'json',
            error: function(jqXHR, textStatus, errorThrown){
              var response = $.parseJSON(jqXHR.responseText);
              //alert(response.description);
            },
            success: function() {
              $(__this).find('form').prepend(`
              <input type="hidden" class="sub-product_meta-property" name="properties[_freegift]" value="Free Gift">
              <input type="hidden" class="sub-product_meta-property" name="properties[_personalize]" value="main">
              <input type="hidden" class="sub-product_meta-property" name="properties[_bundleid]" value="${randomId}">`);
              $(".coupon-confirm-popup").fadeIn(); // Show element
              setTimeout(function () {
                $(".coupon-confirm-popup").fadeOut(); // Hide after 6 sec
              }, 5000);
            }
          });
        }
        if($(__this).find(`.free_gift_product_data:checked`).length > 0){
          addOnProducts();
        }   
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if($(this).hasClass('sale-collection')){
            formData.append('properties[_sections_type]', 'sale-collection');
          }
          this.cart.setActiveElement(document.activeElement);
        }
        if(this.closest('[data-atc-container]')  != null && this.closest('[data-atc-container]').querySelector('[data-product-custom-diet-box] input:checked') != null){
          
          formData.append('properties[_bundle_number]',RandomNumber);
          formData.append('properties[_main_product]',true);
        }        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)

          if(response.properties['_sections_type'] == "sale-collection"){
            window.cartqty = parseInt(window.cartqty) + response.quantity;
            if($('.added_to_cart_strip').length > 0){
              if(window.cartqty >= 1){
                if(!$('.added_to_cart_strip').hasClass('active')){
                  $('.added_to_cart_strip').addClass('active');
                }
                $('.added_to_cart_strip .cart_quantity_count').html(window.cartqty);
              }else{
                $('.added_to_cart_strip').removeClass('active');
              }
            }
          }
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
              if(this.closest('[data-atc-container]')  != null && this.closest('[data-atc-container]').querySelector('[data-product-custom-diet-box] input:checked') != null){          
              this.cart.addAddonItem(this.closest('[data-atc-container]').querySelector('[data-product-custom-diet-box]'),RandomNumber);
            } else{
              this.cart.renderContents(response);
            }
            atcLiveRegion.innerHTML = 'Added to cart';
            
          }
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          
          setTimeout(() =>{
            atcLiveRegion.innerHTML = 'Add to cart';
          },2000)

          if(stickyATCBtn != null){
            stickyATCBtn.querySelector('.product-form__buttons__text').classList.remove('hidden');
            stickyATCBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
          
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
